import { forwardRef } from 'react';
import cx from 'classnames';
import './Button.css';

/**
 * QHS Button v2
 * -------------
 * Variants: 'primary' (gradient, main CTA) | 'solid' (flat brand) | 'secondary'
 *           | 'ghost' | 'link' | 'danger' | 'danger-outline' | 'success'
 * Sizes: 'sm' | 'md' (default) | 'lg'
 * Props: startIcon, endIcon, iconOnly, loading, fullWidth
 */
const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    iconOnly = false,
    loading = false,
    fullWidth = false,
    startIcon,
    endIcon,
    className,
    children,
    disabled,
    type = 'button',
    ...rest
  },
  ref
) {
  const classes = cx(
    'qhs-btn',
    `qhs-btn--${variant}`,
    `qhs-btn--${size}`,
    iconOnly && 'qhs-btn--icon',
    loading && 'qhs-btn--loading',
    fullWidth && 'qhs-btn--full',
    className
  );

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="qhs-btn__spinner" aria-hidden="true" />}
      {!loading && startIcon && <span className="qhs-btn__icon">{startIcon}</span>}
      {!iconOnly && children && <span className="qhs-btn__label">{children}</span>}
      {iconOnly && !loading && children}
      {!loading && endIcon && <span className="qhs-btn__icon">{endIcon}</span>}
    </button>
  );
});

export default Button;
